import React from 'react';
import { FormattedMessage } from 'react-intl';

import { selectAvailableInsuranceOptions } from '../../services/insurance-service';
import * as messages from './messages';

const buildCriterionArgumentObject = (id, displayMessage, value) => {
  return {
    id,
    displayName: <FormattedMessage {...displayMessage} />,
    value,
  };
};

export const staticCriterionArguments = (state) => {
  const insuranceOptions = selectAvailableInsuranceOptions({ state });

  return {
    customerEmail: Object.keys(messages.EmailSentMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.EmailSentMessages[key], key),
    ),
    insurance: insuranceOptions.map((provider) => ({
      displayName: <FormattedMessage {...provider.messageDescriptor} />,
      value: provider.insuranceOptionId,
    })),
    returnsLabel: Object.keys(messages.LabelMessages).map((key) =>
      buildCriterionArgumentObject(key, messages.LabelMessages[key], key === 'printed'),
    ),
  };
};
